export const defaultItem = {
    eyeBool: true,
    eye: 'OD',
    id: 0,
    name: '',
    description: '',
    productNumber: '',
    typeId: null,
    safetyStockLevel: 0,
    reorderPoint: 0,
    unitMeasure: 0,
    currency: '',
    price: 0,
    cost: 0,
    quantity: 0,
    markup: '',
    brandId: null,
    modelId: null,
    profitPercent: 0,
    code: 0,
    preview: '',
    modelScleralId: null,
    typeScleralId: null,
    itemTypes: [],
    lensItem: {
        type: null,
        subType: null,
        material: null,
        treatment: null,
        color: null
    },
    contactLensItem: {
        type: null,
        sphere: null,
        cylinder: null,
        radius: null,
        diameter: null,
        power: null
    },
    frameItem: {
        size: null,
        color: null,
        frameType: null,
        frameHeight: null
    },
    maintenanceItem: {
        subType: null,
        indications: null
    },
    scleralItem: {
        type: 1, //esta campo ya no se usa
        baseCurve: null,
        sagita: null,
        diameter: null,
        power: null,
        cylinder: null,
        sphere: null,
        axis: null,
    },
    areaProductStock: {
        price: 0,
        costAvg: 0
    },
    catalogs: []
};
